const { ZFrontendConfigmap } = require('./schema');

const firebaseDev = {
    apiKey: 'AIzaSyDeUGus981J3DtLLQoC08IXy-0V6TehoWU', // # gitleaks:allow
    authDomain: 'rec-test1.firebaseapp.com',
    projectId: 'rec-test1',
};

const firebaseProd = {
    apiKey: 'AIzaSyDY4QvwgV2Dx4sy4H1LQIRiAxK3hJD2i2Y', // # gitleaks:allow
    authDomain: 'brightsource-prod.firebaseapp.com',
    projectId: 'brightsource-prod',
};

const talentFirebaseDev = {
    apiKey: 'AIzaSyBLyLAgNeOnAf0MFRpiwtIpJAvAG1pDqwM', // # gitleaks:allow
    authDomain: 'talent-test1.firebaseapp.com',
    projectId: 'talent-test1',
};

const talentFirebaseProd = {
    apiKey: 'AIzaSyCJiaUY26MLxotzQctO48YavhaIDafevH4', // # gitleaks:allow
    authDomain: 'talent-prod-24d94.firebaseapp.com',
    projectId: 'talent-prod-24d94',
};

const dataAnnotatorFirebase = {
    apiKey: 'AIzaSyBM6o6kKrFsBCEUUp54fP0RJsoMCo1Z1qY', // # gitleaks:allow
    authDomain: 'mapping-weaver.firebaseapp.com',
    projectId: 'mapping-weaver',
    storageBucket: 'mapping-weaver.firebasestorage.app',
    messagingSenderId: '220139977598',
    appId: '1:220139977598:web:e288f136bbeab68f56912f',
    measurementId: 'G-TF7YLKRW5F',
};

function makeStorage(projectId, bucketName, env, publicBucketName, tempBucketName) {
    const baseUrl = `https://storage.googleapis.com/${bucketName}`;
    const publicBaseUrl = `https://storage.googleapis.com/${publicBucketName}`;
    return {
        cloud: 'gcp',
        projectId,
        bucketName,
        publicBucketName,
        tempBucketName,
        baseUrl,
        publicBaseUrl,
        profileImages: { baseUrl: publicBaseUrl, folder: 'profile-images' },
        companyLogos: { baseUrl: publicBaseUrl, folder: 'company-logos' },
        cvFolder: env === "PROD" ? 'resume-2' : 'resume',
        cvGuestFolder: 'resume-guest',
        cvOnboardingFolder: 'resume-onboarding',
        docsFolder: env === "PROD" ? 'resume-2' : 'resume',
        inboxAttachmentsFolder: 'inbox-attachments',
    };
}

const rawConfig = {
    LOCAL: {
        storage: makeStorage('bs-data-dev-20260315', 'bs-core-bucket-20260315', "LOCAL", 'bs-public-bucket-20260710', 'bs-temp-bucket-20260710'),
        appConfigs: {
            'recruiter-dashboard': {
                env: 'LOCAL',
                apiUrl: 'http://localhost:8006',
                firebase: firebaseDev,
                talentUrl: 'http://localhost:8007',
            },
            'employer-dashboard': {
                env: 'LOCAL',
                apiUrl: 'http://localhost:8001',
                firebase: firebaseDev,
            },
            'talent-dashboard': {
                env: 'LOCAL',
                apiUrl: 'http://localhost:8007',
                firebase: talentFirebaseDev,
                ethosiaHostname: 'talents.dev.brightsource.com',
                ethosiaCompanySlug: 'conDl-OE_Wv8',
            },
            'profile-crawler-extension': {
                env: 'LOCAL',
                apiUrl: 'http://localhost:8005',
                firebase: {
                    ...firebaseDev,
                    databaseURL: 'https://rec-test1.firebaseio.com',
                    storageBucket: 'rec-test1.appspot.com',
                    messagingSenderId: '553142588603',
                },
                webUrl: 'https://recruiters.dev.brightsource.com',
            },
            'linkedin-scraping-dashboard': {
                env: 'LOCAL',
                apiUrl: 'https://dev-api.tiro.io',
                firebase: {
                    ...firebaseDev,
                    appId: '1:553142588603:web:8c79cba5e6931f3f49859e',
                },
            },
            'landing-page': {
                env: 'LOCAL',
                apiUrl: 'https://api.dev.brightsource.com/landing-page',
                talentUrl: 'https://talents.dev.brightsource.com',
            },
            'data-annotator-dashboard': {
                env: 'LOCAL',
                apiUrl: 'http://localhost:8000',
                firebase: dataAnnotatorFirebase,
            },
            'profile-crawler-extension-dispatcher': {
                env: 'LOCAL',
                webUrl: 'http://localhost:3000',
            },
        },
    },
    DEV: {
        storage: makeStorage('bs-data-dev-20260315', 'bs-core-bucket-20260315', undefined, 'bs-public-bucket-20260710', 'bs-temp-bucket-20260710'),
        appConfigs: {
            'recruiter-dashboard': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/recruiter',
                firebase: firebaseDev,
                talentUrl: 'https://talents.dev.brightsource.com',
            },
            'employer-dashboard': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/employer',
                firebase: firebaseDev,
                webUrl: 'employers.dev.brightsource.com',
            },
            'talent-dashboard': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/talent',
                firebase: talentFirebaseDev,
                ethosiaHostname: 'talents.dev.brightsource.com',
                ethosiaCompanySlug: 'conDl-OE_Wv8',
            },
            'profile-crawler-extension': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/profile-crawler-extension',
                firebase: {
                    ...firebaseDev,
                    databaseURL: 'https://rec-test1.firebaseio.com',
                    storageBucket: 'rec-test1.appspot.com',
                    messagingSenderId: '553142588603',
                },
                webUrl: 'https://recruiters.dev.brightsource.com',
            },
            'linkedin-scraping-dashboard': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/linkedin-scraping',
                firebase: {
                    ...firebaseDev,
                    appId: '1:553142588603:web:8c79cba5e6931f3f49859e',
                },
            },
            'landing-page': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/landing-page',
                talentUrl: 'https://talents.dev.brightsource.com',
            },
            'data-annotator-dashboard': {
                env: 'DEV',
                apiUrl: 'https://api.dev.brightsource.com/data-annotator',
                firebase: dataAnnotatorFirebase,
            },
            'profile-crawler-extension-dispatcher': {
                env: 'DEV',
                webUrl: 'https://recruiters.dev.brightsource.com',
            },
        },
    },
    PROD: {
        // publicBucketName/tempBucketName are anticipated names - not yet created in the
        // bff-prod-223208 GCP project. Tracked in BS-381; create before any prod code path
        // reads these fields.
        storage: makeStorage('bff-prod-223208', 'bff-prod-223208.appspot.com', "PROD", 'bs-public-bucket-prod-20260710', 'bs-temp-bucket-prod-20260710'),
        appConfigs: {
            'recruiter-dashboard': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/recruiter',
                firebase: firebaseProd,
                talentUrl: 'https://talents.brightsource.com',
            },
            'employer-dashboard': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/employer',
                firebase: firebaseProd,
                webUrl: 'employers.brightsource.com',
            },
            'talent-dashboard': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/talent',
                firebase: talentFirebaseProd,
                ethosiaHostname: 'talents.ethosia.co.il',
                ethosiaCompanySlug: 'conDl-OE_Wv8',
            },
            'profile-crawler-extension': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/profile-crawler-extension',
                firebase: {
                    ...firebaseProd,
                    databaseURL: 'https://brightsource-prod.firebaseio.com',
                    storageBucket: 'bs-public-bucket-prod-20260710',
                    messagingSenderId: '487762325463',
                },
                webUrl: 'https://rec.ethosia.co.il',
            },
            'linkedin-scraping-dashboard': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/linkedin-scraping',
                firebase: {
                    ...firebaseProd,
                    appId: '1:487762325463:web:ad10783446b13e02aa6592',
                },
            },
            'landing-page': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/landing-page',
                talentUrl: 'https://talents.ethosia.co.il',
            },
            'data-annotator-dashboard': {
                env: 'PROD',
                apiUrl: 'https://api.brightsource.com/data-annotator',
                firebase: dataAnnotatorFirebase,
            },
            'profile-crawler-extension-dispatcher': {
                env: 'PROD',
                webUrl: 'https://rec.ethosia.co.il',
            },
        },
    },
};

module.exports = ZFrontendConfigmap.parse(rawConfig);
